import { isEmpty } from 'lodash-es';
import { useScopedAppFlagStore } from '@frontend/scope';
import { FeatureFlagStrategy, useAppFlagStore } from '@frontend/shared';
import { useLocalStorage } from '@frontend/web-storage';
import { FEATURE_FLAG_MAP, FeatureFlagKey } from './feature-flag-registry';

export const createFeatureFlagHook = (flagKey: FeatureFlagKey, strategy: FeatureFlagStrategy = 'ALL') => {
  const config = FEATURE_FLAG_MAP[flagKey];

  if (!config) {
    throw new Error(`Feature flag config not found for key: ${flagKey}`);
  }

  return () => {
    const [isFFOverride] = useLocalStorage({
      key: config.localStorageName,
      // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
      defaultValue: localStorage.getItem(config.localStorageName) === 'true',
    });

    // App flag store
    const { featureFlags } = useAppFlagStore();
    const isFeatureFlagsLoaded = !isEmpty(featureFlags);

    // Scoped feature flag
    const { getFeatureFlagValue } = useScopedAppFlagStore();
    const hasFF = getFeatureFlagValue(config.flagName, strategy);

    const isLoading = !isFeatureFlagsLoaded;
    const isEnabled = (!isLoading && hasFF) || !!isFFOverride;

    return {
      isLoading,
      isFFOverride,
      isEnabled,
    };
  };
};
